import {createApi} from '../../../redux/helpers'
import {helpers} from '@teamrazr/redux'

export const createActions = createApi(
  process.browser ? '/api/ps' : 'http://localhost:8080/api/ps'
)

export const shippingBillingDetails = createActions(
  'checkout/GetShippingAndBillingDetails',
  ['shipping_billing_details'],
  'shipping_billing_details'
)

export const shippingAddressDetails = createActions(
  'checkout/UpdateShippingAddress',
  ['shipping_address_details'],
  'shipping_address_details'
)

export const shoppingCartDetails = createActions(
  'cart/GetCartDetails',
  ['cart_details'],
  'cart_details'
)

export const statesList = createActions(
  'checkout/GetStateList',
  ['state_list'],
  'state_list'
)

export const billingStatesList = createActions(
  'checkout/GetStateList',
  ['billing_state_list'],
  'billing_state_list'
)

export const shippingAndBillingSave = createActions(
  'checkout/CreateOrder',
  ['shipping_billing_save'],
  'shipping_billing_save'
)

export const deleteCartItem = createActions(
  'cart/remove',
  ['delete_cart_item'],
  'delete_cart_item'
)

export const updateCartQuantity = createActions(
  'cart/QtyUpdate',
  ['update_cart_quantity'],
  'update_cart_quantity'
)

export const submitCouponCode = createActions(
  'cart/SubmitCoupon',
  ['coupon_code'],
  'coupon_code'
)

export const previewProduct = createActions(
  'webapi/v2/product/change',
  ['preview_product'],
  'preview_product'
)

export const addToCart = createActions(
  'webapi/v2/product/AddToCart',
  ['add_to_cart'],
  'add_to_cart'
)

export const productRecommendations = createActions(
  'webapi/v2/product/WhatOthersBuying',
  ['product_recommendations'],
  'product_recommendations'
)

export const cancelOrder = createActions(
  'account/CancelOrder',
  ['cancel_order'],
  'cancel_order'
)

export const productDesigns = createActions(
  'products/designs',
  ['product_designs'],
  'product_designs'
)

export const categoryDesigns = createActions(
  'store/GetProductListDesigns',
  ['category_designs'],
  'category_designs'
)

export const resetProductReviews = helpers.createAction('RESET_PRODUCT_REVIEWS')
